import { ReactNode } from 'react';

import { Dropdown, DropdownIndicator } from 'approot/shared/dropdown/dropdown';
import { DropdownItem } from 'approot/shared/dropdown/dropdown-item.style';
import {
  DownloadButton,
  DownloadButtonContent,
} from './content-page-action-dropdown.style';

type Props = {
  buttonLabel?: string;
  dropdownOptions: {
    text: string;
    disabled?: boolean;
    onClick: () => void;
  }[];
  icon?: ReactNode;
  ariaLabel?: string;
};

const ContentPageActionDropdown = ({
  dropdownOptions,
  buttonLabel = 'Download',
  icon,
  ariaLabel = 'Download options',
}: Props) => {
  if (dropdownOptions.length === 0) return null;

  const buttonContent = icon ? (
    <DownloadButton
      type="button"
      aria-haspopup="listbox"
      data-selector="action-button"
    >
      {icon}
      <DownloadButtonContent>{buttonLabel}</DownloadButtonContent>
      <DropdownIndicator />
    </DownloadButton>
  ) : undefined;

  return (
    <Dropdown
      borderRadius={8}
      aria-label={ariaLabel}
      data-selector="action-button"
      placement="bottom-end"
      buttonElement={!icon ? buttonLabel : undefined}
      dropdownButtonContents={buttonContent}
      dropdownContents={dropdownOptions.map((d, i) => (
        <DropdownItem key={i} disabled={d.disabled} onClick={d.onClick}>
          {d.text}
        </DropdownItem>
      ))}
    />
  );
};

export default ContentPageActionDropdown;
